
import classes from './project.module.css'; 
import git from '../../assest/github.png';
import { motion } from "framer-motion";




const card = (props)=>{
  const ani1 = {
    hidden:{
      
        x:'10vh',
        opacity:0
    },
    visible:{
        y:0,
        x:0,
        opacity:1,
        transition:{
            delay:1,duration:0.6,type:'spring'
        },
      
        exit:{
          x: -300, opacity: 0 ,
            transition:{
              delay:3,duration:0.6,type:'spring'
          }
        }
        
  
    }
  }

    const info = props.info;
    const c1 = ["col-sm-12 col-md-6 col-lg-5 card",classes.card1];
    const c2= ["btn btn-block btn-dark",classes.card1];
    const c3 = ["card-img-top",classes.imgcard];
    const{name,url,github,image} = info;
   // console.log(info);
    return(
     
        <motion.div 
        variants={ani1}
        initial='hidden'
        animate='visible'
        
        className={c1.join(' ')}  style={{
            "borderRadius":"20px",
            "margin":"20px",
            // "marginRight":"20px",
            "backgroundColor":"#404040",
            "boxShadow":"0px 0px 2px 6px silver"
        }}
       >
  <a href={url} target="_blank" ><img className={c3.join(' ')}src={image} alt="projects" /></a>
  <div className="card-body">
    
    
    <a href={github} target="_blank" className={c2.join(' ')}><img className={classes.icon} src={git} alt="icon" />{name}</a>
  </div>
</motion.div>

      
        

    )
}
export default card;